
import { ref } from 'vue'
import { $t as lang } from '@/Tool' 

export default {
  setup() {
    interface SkinItem {
      name: string
      id: number
      color: string
    }
    const skins = ref<Array<SkinItem>>([
      { name: lang('finite.skin.theme.blue'), id: 1, color: '#409eff' },
      { name: lang('finite.skin.theme.black'), id: 2, color: '#000000' },
    ])
    const currentSkin = ref<SkinItem>({} as SkinItem)
    function clickSkin(item: SkinItem) {
      currentSkin.value = item
    }
    clickSkin(skins.value[0])

    return {
      skins,
      currentSkin,
      clickSkin,
      lang,
    }
  },
}
